export default function fixedEncodeURIComponent(str: string | URL) {
  // See: https://stackoverflow.com/a/61583006
  return encodeURIComponent(str.toString()).replace(
    /[!'()*]/g,
    (c) => `%${c.charCodeAt(0).toString(16)}`,
  );
}
